import * as React from "react";
import { forwardRef } from "react";
const SvgHome = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 18.9997H9.34625V13.0575H14.6538V18.9997H18V9.99972L12 5.48047L6 9.99972V18.9997ZM4.5 20.4997V9.24972L12 3.60547L19.5 9.24972V20.4997H13.1538V14.5575H10.8463V20.4997H4.5Z", fill: "#1B1B1E" }));
const ForwardRef = forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
